<template>
    <otif-table :columns="columns" :rows="rows" :paginated="false" :title="title" @change="onChange" ref="dcTable"/>
</template>
<script>

import axios from 'axios';

export default {

    data() {
        return {
            loading: false,
            rows: [],
            original_data: {},
            columns: [{
                name: 'format',
                label: 'Format'
            }],
            title: 'Date Conversions'
        }
    },

    methods: {
        async load() {
            this.loading = true;

            const res = await axios.get('/mtm-gateway-api/v1/services/pipeline/conversion');

            this.rows = res.data.conversionDateFormats.value.map((fmt) => {
                return [fmt.format];
            });

            this.original_data = res.data;
        },

        async onChange($evt) {
            this.$snotify.info('Saving');

            const newRows = $evt.rows.map((row) => {
                return {
                    format: row[0]
                };
            });

            const newData = JSON.parse(JSON.stringify(this.original_data));
            newData.conversionDateFormats.value = newRows;

            try {
                const res = await axios.put('/mtm-gateway-api/v1/services/pipeline/conversion', newData);

                this.original_data = res.data;

                this.rows = res.data.conversionDateFormats.value.map((fmt) => {
                    return [fmt.format];
                });

                this.$snotify.clear();
                this.$snotify.success('Saved');
            } catch (err) {

                console.error(err);

                this.rows = this.original_data.conversionDateFormats.value.map((fmt) => {
                    return [fmt.format];
                });

                this.$snotify.clear();
                this.$snotify.error('An error occurred saving the date conversions');
            }
        }

    },

    mounted() {
        this.load();
    }
}
</script>
